import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa'; // Using FaCheckCircle from react-icons
import axios from 'axios';
import { API_BASE_URL } from "../utils/urls";
// NOTE: You will need the appropriate routing setup (like React Router DOM) 
// to correctly use the useLocation and useNavigate hooks.
const BACKEND_VERIFY_URL = API_BASE_URL + '/subscription/verify-session';

const SignupSuccessPage = () => {
    // Hooks to access URL data and navigation
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setVerificationStatus] = useState('success'); // 'success', 'error', 'loading'
    const [message, setMessage] = useState('Your trial setup is complete!');

    // Extract the session_id from the URL query parameters
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');


    const verifyAndLogin = async (sessionId) => {
        try {
            // Call the backend endpoint to verify the session and get the JWT
            const response = await axios.post(BACKEND_VERIFY_URL, { sessionId });

            const { token } = response.data;
            console.log(response.data)

            if (token) {
                // GTM payment success event
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "payment_success",
                    plan: response.data?.subscription?.planName,
                    billing: response.data?.subscription?.billingInterval
                });
                // 1. Successful verification: Store the JWT for immediate login
                // NOTE: In a professional app, you might use a cookie, but localStorage is common here.
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("user", JSON.stringify(response.data.user));
                setVerificationStatus('success');
                const roleName = response.data.user.roleName;
                switch (roleName) {
                    case "admin":
                        //navigate("/dashboard/admin");
                        break;
                    default:
                        navigate("/dashboard");
                }
                //2. Redirect to the dashboard after a short delay
                // setTimeout(() => {
                //     navigate('/dashboard', { replace: true });
                // }, 3000); 
            } else {
                setVerificationStatus('failed');
                setMessage('Verification failed: Authentication token missing.');
            }
        } catch (error) {
            console.error('Stripe Session Verification Error:', error.response?.data || error.message);
            setVerificationStatus('failed');
            // Provide a user-friendly message, defaulting to the server's error message
            setMessage(error.response?.data?.message || 'Could not verify subscription. Please contact support.');
        }
    };

    useEffect(() => {
        // --- Verify Session ID and Handle Finalization ---

        // This effect runs once on component mount
        if (!sessionId) {
            setVerificationStatus('error');
            setMessage('Invalid verification link. Please check your email or contact support.');
            return;
        }
        verifyAndLogin(sessionId);


        // Simulate redirection after successful signup/trial initiation
        const timer = setTimeout(() => {
            // Replace with your actual dashboard route
            //navigate('/dashboard', { replace: true }); 
        }, 5000); // Redirects after 5 seconds

        return () => clearTimeout(timer); // Cleanup timer on component unmount
    }, [sessionId, navigate]);

    if (status === 'loading') {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <p className="text-xl text-gray-700">Verifying setup...</p>
            </div>
        );
    }

    // Determine button and message based on final status
    const isSuccess = status === 'success';

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
            <div className={`p-8 sm:p-12 rounded-2xl shadow-2xl max-w-lg w-full ${isSuccess ? 'bg-white' : 'bg-red-50'}`}>

                {/* Icon */}
                <div className="flex justify-center mb-6">
                    <FaCheckCircle className={`w-16 h-16 ${isSuccess ? 'text-green-500' : 'text-red-500'}`} />
                </div>

                {/* Title */}
                <h2 className="text-3xl font-extrabold text-gray-900 mb-3">
                    {isSuccess ? 'Trial Started Successfully!' : 'Setup Failed'}
                </h2>

                {/* Message */}
                <p className="text-lg text-gray-600 mb-6">
                    {isSuccess
                        ? message
                        : 'There was an issue processing your subscription. Please contact support or try again.'}
                </p>

                {isSuccess && (
                    <p className="text-sm text-gray-500 mb-8">
                        You have started your 14-day free trial. We are now preparing your account. You will be redirected shortly.
                    </p>
                )}

                {/* Call to Action */}
                <button
                    onClick={() => navigate('/dashboard/admin', { replace: true })}
                    className={`w-full py-3 font-semibold rounded-lg shadow-md transition duration-300 
                        ${isSuccess ? 'bg-sky-600 hover:bg-sky-700' : 'bg-gray-500 hover:bg-gray-600'} text-white
                    `}
                >
                    Go to Dashboard Now
                </button>
            </div>
        </div>
    );
};

export default SignupSuccessPage;
